import React from "react";
import Button from "../../Common/Button/button";
import Filters from "../../Common/Filters/filters";
import TableActions from "../../Common/TableActions/tableactions";
import { Row, Col, Select, Form, Table, DatePicker } from "antd";
import PickupDashboardService from "../../../services/pickupdashboard.service";
import { labels } from "../../../shared/language";
import moment from "moment";
const { Option } = Select;
const ONE_MONTHS_AGO = new Date();
ONE_MONTHS_AGO.setMonth(ONE_MONTHS_AGO.getMonth() - 1);

export default class pickupdashboard extends React.Component {
  constructor(props) {
    super(props);
    this.PickupService = new PickupDashboardService();
    this.state = {
      selectedBranch: localStorage.getItem("branchID"),
      orderFromDate: moment(ONE_MONTHS_AGO),
      orderToDate: moment(),
      attention: {},
      cancellations: [],
      actionItems: [],
      actionPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      byStore: [],
      agents: [],
      byStoreLoaded: false,
      byStoreLoading: false,
      agentsLoaded: false,
      agentsLoading: false,
      loading: false,
    };
  }

  ActionColumns = [
    { title: "Pickup #", dataIndex: "splitOrderNumber", key: "splitOrderNumber" },
    { title: "Store", dataIndex: "shortName", key: "shortName" },
    { title: "Slot", dataIndex: "slot", key: "slot" },
    {
      title: "Issue", dataIndex: "issue", key: "issue",
      render: (t) => {
        const c = t === "Not picked" ? "#b3261e" : t === "Not billed" ? "#5b2ca8" : "#8a5a06";
        const bg = t === "Not picked" ? "#fdecec" : t === "Not billed" ? "#f3ecfe" : "#faf0dd";
        return (<span style={{ background: bg, color: c, fontSize: 11, fontWeight: 500, padding: "2px 9px", borderRadius: 20 }}>{t}</span>);
      },
    },
    { title: "Owner", dataIndex: "agentName", key: "agentName" },
    { title: "Age", dataIndex: "ageHrs", key: "ageHrs", render: (t) => (<span style={{ fontWeight: 600 }}>{t}h</span>) },
    { title: "₹ value", dataIndex: "amount", key: "amount", render: (t) => (t > 0 ? "₹" + Math.round(t).toLocaleString("en-IN") : "—") },
  ];

  componentDidMount() {
    this.fetchAll();
  }

  baseParam = () => ({
    FromOrderDate: this.state.orderFromDate,
    ToOrderDate: this.state.orderToDate,
    StoreId: this.state.selectedBranch,
  });

  fetchAll = () => {
    const base = this.baseParam();
    this.setState({ loading: true, byStoreLoaded: false, agentsLoaded: false });
    this.PickupService.getPickupAttention(base).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({ attention: res.data && res.data.length > 0 ? res.data[0] : {} });
      }
    });
    this.PickupService.getPickupCancellations(base).then((res) => {
      if (res && res.statusCode === 200) { this.setState({ cancellations: res.data || [] }); }
    });
    const ap = this.state.actionPagination;
    this.PickupService.getPickupActionList({ ...base, pageIndex: ap.current, pageSize: ap.pageSize }).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({
          actionItems: res.data || [],
          actionPagination: { ...ap, total: res.data && res.data.length > 0 ? res.data[0].totalRecords : 0 },
          loading: false,
        });
      } else { this.setState({ loading: false }); }
    });
  };

  fetchByStore = () => {
    this.setState({ byStoreLoading: true });
    this.PickupService.getPickupByStore(this.baseParam()).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({ byStore: res.data || [], byStoreLoaded: true, byStoreLoading: false });
      } else { this.setState({ byStoreLoading: false }); }
    });
  };

  fetchAgents = () => {
    this.setState({ agentsLoading: true });
    this.PickupService.getPickupAgentLeaderboard(this.baseParam()).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({ agents: res.data || [], agentsLoaded: true, agentsLoading: false });
      } else { this.setState({ agentsLoading: false }); }
    });
  };

  handleActionTableChange = (pagination) => {
    this.setState({ actionPagination: pagination }, () => {
      this.PickupService.getPickupActionList({
        ...this.baseParam(), pageIndex: pagination.current, pageSize: pagination.pageSize,
      }).then((res) => {
        if (res && res.statusCode === 200) {
          this.setState({
            actionItems: res.data || [],
            actionPagination: { ...pagination, total: res.data && res.data.length > 0 ? res.data[0].totalRecords : 0 },
          });
        }
      });
    });
  };

  handleDateChange = (date, key) => this.setState({ [key]: date });

  render() {
    const storeBranchTypes = ![undefined, null, ""].includes(localStorage.getItem("BranchInfo"))
      ? JSON.parse(localStorage.getItem("BranchInfo")).filter((x) => x.branchType === "Store") : [];
    const att = this.state.attention || {};
    const money = (v) => "₹" + Math.round(v || 0).toLocaleString("en-IN");
    const attCard = (c) => ({ border: "1px solid #eee", borderLeft: "3px solid " + c, borderRadius: 8, padding: "10px 13px" });
    const attNum = (c) => ({ fontSize: 24, fontWeight: 700, color: c, lineHeight: 1.1 });
    const attLbl = { fontSize: 12, color: "#6b6b6b", marginTop: 4 };
    const attAmt = { fontSize: 12, color: "#555", marginTop: 2, fontWeight: 600 };
    const dot = (c) => ({ display: "inline-block", width: 9, height: 9, background: c, borderRadius: 2, marginRight: 4 });
    const sub = { fontSize: 11, color: "#999", marginTop: 2 };
    const onTimeRate = (att.accountableTotal || 0) > 0 ? Math.round(((att.onTime || 0) / att.accountableTotal) * 100) : 0;
    const storeSide = att.storeSideMiss || 0;
    const custSide = att.customerSideMiss || 0;
    const missTotal = storeSide + custSide;
    const storePct = missTotal > 0 ? Math.round((storeSide / missTotal) * 100) : 0;
    // funnel
    const fmax = Math.max(att.requested || 1, 1);
    const fw = (v) => ((v || 0) / fmax) * 100 + "%";
    const ActionListItems = (this.state.actionItems || []).map((it, i) => ({ key: (it.splitOrderNumber || "") + i, ...it }));
    // cancellations split
    const cx = (this.state.cancellations || []).filter((r) => r.category === "Customer");
    const ops = (this.state.cancellations || []).filter((r) => r.category === "Ops");
    const cxTotal = cx.reduce((a, r) => a + (r.cnt || 0), 0);
    const opsTotal = ops.reduce((a, r) => a + (r.cnt || 0), 0);
    const cancTotal = cxTotal + opsTotal;
    const cxPct = cancTotal > 0 ? Math.round((cxTotal / cancTotal) * 100) : 0;
    const topReasons = (this.state.cancellations || []).slice().sort((a, b) => (b.cnt || 0) - (a.cnt || 0)).slice(0, 8);

    return (
      <div>
        <div style={{ fontSize: 20, fontWeight: 600, margin: "4px 0 12px" }}>Pickup Dashboard</div>

        <Filters show={true}>
          <Form onFinish={this.fetchAll}>
            <Row gutter={16} align="middle">
              <Col xs={24} lg={5}>
                <Form.Item name="fromDate">
                  <DatePicker placeholder={labels.FROM_DATE} format={"DD-MM-YYYY"}
                    onChange={(d) => this.handleDateChange(d, "orderFromDate")} value={this.state.orderFromDate}
                    disabledDate={(c) => c.isAfter(moment(), "day")} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} lg={5}>
                <Form.Item name="toDate">
                  <DatePicker placeholder={labels.TO_DATE} format={"DD-MM-YYYY"}
                    onChange={(d) => this.handleDateChange(d, "orderToDate")} value={this.state.orderToDate}
                    disabledDate={(c) => c.isAfter(moment(), "day")} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} lg={10}>
                <Form.Item name="storeId">
                  <Select showSearch mode="multiple" allowClear placeholder={labels.SELECT_STORE}
                    onChange={(event) => this.setState({ selectedBranch: [null, undefined, ""].includes(event) ? "" : event.join(",") })}
                    value={[null, undefined, ""].includes(this.state.selectedBranch) ? [localStorage.getItem("branchID")] : this.state.selectedBranch.split(",")}
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {storeBranchTypes.map((b) => b.branchID !== "-1" ? (
                      <Option value={b.branchID.toString()} key={b.branchID.toString()}>{b.branchName}</Option>
                    ) : null)}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} lg={4}>
                <Button htmlType="submit" variant="whitePink" shape="round" size="large">Apply</Button>
              </Col>
            </Row>
          </Form>
        </Filters>

        <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fff7fb", border: "1px solid #ffd9ea", borderRadius: 10, padding: "10px 14px", margin: "6px 0 16px", fontSize: 13 }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#fe1d7f" }} />
          <span>SLA {"—"} on time = picked in the booked slot and billed within 3 hours. Customer cancellations are excluded from the store's miss numbers.</span>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 10, marginBottom: 14 }}>
          <div style={{ ...attCard("#fe1d7f"), background: "#fffafc" }}>
            <div style={attNum("#fe1d7f")}>{onTimeRate}%</div><div style={attLbl}>On-time rate</div>
            <div style={sub}>of {att.accountableTotal || 0} accountable</div>
          </div>
          <div style={attCard("#2f9e6f")}>
            <div style={attNum("#2f9e6f")}>{att.onTime || 0}</div><div style={attLbl}>On time</div>
            <div style={attAmt}>{money(att.onTimeValue)}</div>
            <div style={sub}>{att.onTimeInSlot || 0} in-slot + grace</div>
          </div>
          <div style={attCard("#c67f00")}>
            <div style={attNum("#c67f00")}>{att.late || 0}</div><div style={attLbl}>Late</div>
            <div style={attAmt}>{money(att.lateValue)}</div>
            <div style={sub}>billed &gt;3h after slot</div>
          </div>
          <div style={attCard("#e5484d")}>
            <div style={attNum("#e5484d")}>{att.notPicked || 0}</div><div style={attLbl}>Not picked</div>
            <div style={sub}>slot passed, still open</div>
          </div>
          <div style={attCard("#7c3aed")}>
            <div style={attNum("#7c3aed")}>{att.pickedNotBilled || 0}</div><div style={attLbl}>Picked, not billed</div>
            <div style={sub}>collected, no invoice</div>
          </div>
          <div style={attCard("#6b7280")}>
            <div style={attNum("#6b7280")}>{att.execCancelled || 0}</div><div style={attLbl}>Cancelled (ops)</div>
            <div style={sub}>+ {att.cxCancelled || 0} by customer</div>
          </div>
        </div>

        {missTotal > 0 ? (
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Who owns the misses</div>
            <div style={{ display: "flex", height: 24, borderRadius: 6, overflow: "hidden", marginBottom: 5 }}>
              <div style={{ width: storePct + "%", background: "#fe1d7f", display: "flex", alignItems: "center", paddingLeft: 10, color: "#fff", fontSize: 12, whiteSpace: "nowrap" }}>{"Store / agent " + storeSide + " (" + storePct + "%)"}</div>
              <div style={{ width: (100 - storePct) + "%", background: "#2563eb" }} />
            </div>
            <div style={{ fontSize: 11, color: "#666" }}>
              <span><span style={dot("#fe1d7f")} /> Store / agent {storeSide} {"—"} late, not picked, not billed, ops-cancelled</span>
              <span style={{ marginLeft: 16 }}><span style={dot("#2563eb")} /> Customer {custSide} ({100 - storePct}%)</span>
            </div>
          </div>
        ) : null}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 }}>
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Pickup funnel</div>
            <div style={{ border: "1px solid #eee", borderRadius: 12, padding: "14px 16px" }}>
              {[["Requested", att.requested], ["Assigned", att.assigned], ["Picked up", att.picked], ["Billed", att.billed], ["On time", att.onTime]].map((r) => (
                <div key={r[0]} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <div style={{ width: 88, fontSize: 13 }}>{r[0]}</div>
                  <div style={{ flex: 1, background: "#f0f0f2", borderRadius: 5, height: 20, overflow: "hidden" }}>
                    <div style={{ width: fw(r[1]), height: "100%", background: "linear-gradient(90deg,#ffd0e4,#fe1d7f)" }} />
                  </div>
                  <div style={{ width: 70, textAlign: "right", fontWeight: 500, fontSize: 13 }}>{(r[1] || 0).toLocaleString("en-IN")}</div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Cancellations {"—"} consolidated ({cancTotal})</div>
            <div style={{ border: "1px solid #eee", borderRadius: 12, padding: "14px 16px" }}>
              <div style={{ display: "flex", height: 20, borderRadius: 6, overflow: "hidden", marginBottom: 10 }}>
                <div style={{ width: cxPct + "%", background: "#2563eb" }} />
                <div style={{ width: (100 - cxPct) + "%", background: "#c67f00" }} />
              </div>
              <div style={{ fontSize: 11, color: "#666", marginBottom: 8 }}>
                <span><span style={dot("#2563eb")} /> Customer {cxTotal}</span>
                <span style={{ marginLeft: 14 }}><span style={dot("#c67f00")} /> Ops {opsTotal}</span>
              </div>
              <table style={{ width: "100%", fontSize: 13 }}>
                <tbody>
                  {topReasons.map((r, i) => (
                    <tr key={i}>
                      <td style={{ padding: "4px 0", borderBottom: "1px solid #f2f2f2", color: "#666" }}>
                        <span style={{ fontSize: 10, padding: "1px 6px", borderRadius: 10, marginRight: 6, background: r.category === "Customer" ? "#e8f0fe" : "#faeede", color: r.category === "Customer" ? "#1a56b8" : "#8a5a06" }}>{r.category === "Customer" ? "Cx" : "Ops"}</span>
                        {(r.reason || "").length > 34 ? (r.reason || "").slice(0, 34) + "…" : r.reason}
                      </td>
                      <td style={{ padding: "4px 0", borderBottom: "1px solid #f2f2f2", textAlign: "right" }}>{r.cnt}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div style={{ fontWeight: 600, margin: "0 2px 8px" }}>Action list {"—"} needs attention <span style={{ fontWeight: 400, color: "#888", fontSize: 12 }}>(worst first)</span></div>
        <Table size="small" columns={this.ActionColumns} dataSource={ActionListItems}
          pagination={this.state.actionPagination} loading={this.state.loading} onChange={this.handleActionTableChange} />
        <TableActions isPagination={true}></TableActions>

        <div style={{ marginTop: 18 }}>
          {!this.state.agentsLoaded ? (
            <button onClick={this.fetchAgents} disabled={this.state.agentsLoading}
              style={{ padding: "6px 14px", fontSize: 13, border: "1px solid #d0d0d0", borderRadius: 6, background: "#fafafa", cursor: "pointer", color: "#333" }}>
              {this.state.agentsLoading ? "Loading agent leaderboard..." : "Show agent leaderboard"}
            </button>
          ) : (
            <div>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>Agent leaderboard {"—"} on-time %</div>
              <Table size="small" pagination={false}
                columns={[
                  { title: "Pickup executive", dataIndex: "agentName", key: "agentName" },
                  { title: "Pickups", dataIndex: "pickups", key: "pickups", align: "right" },
                  { title: "Not billed", dataIndex: "notBilled", key: "notBilled", align: "right" },
                  { title: "Avg bill lag", dataIndex: "avgBillLagMin", key: "avgBillLagMin", align: "right", render: (t) => Math.round((t || 0) / 60 * 10) / 10 + "h" },
                  { title: "On-time", dataIndex: "onTimeRate", key: "onTimeRate", align: "right", render: (t) => (<span style={{ fontWeight: 600, color: t < 70 ? "#e5484d" : "#2f9e6f" }}>{t}%</span>) },
                ]}
                dataSource={(this.state.agents || []).map((a, i) => ({ key: a.agentId || i, ...a }))} />
            </div>
          )}
        </div>

        <div style={{ marginTop: 18 }}>
          {!this.state.byStoreLoaded ? (
            <button onClick={this.fetchByStore} disabled={this.state.byStoreLoading}
              style={{ padding: "6px 14px", fontSize: 13, border: "1px solid #d0d0d0", borderRadius: 6, background: "#fafafa", cursor: "pointer", color: "#333" }}>
              {this.state.byStoreLoading ? "Loading store breakdown..." : "Show by-store breakdown (admin)"}
            </button>
          ) : (
            <div>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>By store</div>
              <Table size="small" pagination={false}
                columns={[
                  { title: "Store", dataIndex: "shortName", key: "shortName" },
                  { title: "Pickups", dataIndex: "pickups", key: "pickups", align: "right" },
                  { title: "Late", dataIndex: "late", key: "late", align: "right" },
                  { title: "Not picked", dataIndex: "notPicked", key: "notPicked", align: "right" },
                  { title: "Not billed", dataIndex: "notBilled", key: "notBilled", align: "right" },
                  { title: "Cancelled", dataIndex: "cancelled", key: "cancelled", align: "right" },
                  { title: "On-time", dataIndex: "onTimeRate", key: "onTimeRate", align: "right", render: (t) => (<span style={{ fontWeight: 600, color: t < 70 ? "#e5484d" : "#2f9e6f" }}>{t}%</span>) },
                ]}
                dataSource={(this.state.byStore || []).map((s, i) => ({ key: s.storeID || i, ...s }))} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
